require('module-composer/src/core/extensions').register('eject', require('module-composer/src/extensions/eject'));
